import { clamp, round } from 'lodash';
import type { Dimension } from 'types/common_types';

/** Calculate how to resize the image to fit in the node */
export function fitImageToNode(nodeDimensions: Dimension, imageDimensions: Dimension) {
  const { height: nodeH, width: nodeW } = nodeDimensions;
  const { height: imageH, width: imageW } = imageDimensions;
  const scalingFactor = getScalingFactor(nodeDimensions, imageDimensions);

  const fitCropW = round(nodeW / (imageW * scalingFactor), 6);
  const fitCropH = round(nodeH / (imageH * scalingFactor), 6);

  return { fitCropH, fitCropW };
}

/** Get scaling factor for fitting image to node */
export function getScalingFactor(nodeDimensions: Dimension, imageDimensions: Dimension) {
  const { height: nodeH, width: nodeW } = nodeDimensions;
  const { height: imageH, width: imageW } = imageDimensions;

  const widthRatio = nodeW / imageW;
  const heightRatio = nodeH / imageH;
  return Math.max(widthRatio, heightRatio);
}

/**
 * Calculate the pan limits of a crop based on a cropped dimension
 *
 * Based on crop points being calculated as % off center, as a decimal
 */
export function clampCropPanToLimit(cropDimension: number, cropPoint: number) {
  const halfCrop = (1 - cropDimension) / 2;
  return clamp(cropPoint, 0.5 - halfCrop, 0.5 + halfCrop);
}
